import { useQuery } from "@tanstack/react-query";
import { ReviewServices } from "@/services/bedrock/ReviewServices";
import { ReviewPostSummary } from "@/services/bedrock/dtos/ReviewPost";
import { designKeys } from "@/services/bedrock/queryKeys";

const PENDING_POLL_MS = 15_000;

function hasPendingPost(posts: ReviewPostSummary[] | undefined): boolean {
  return !!posts?.some(post => post.status === "scheduled" || post.status === "posting");
}

/** Posts made from a review, newest first; polls while one is still scheduled or posting. */
export function useReviewPosts(reviewId: string | number | null | undefined) {
  return useQuery({
    queryKey: designKeys.reviewPosts(reviewId ?? ""),
    queryFn: () => ReviewServices.getReviewPosts(reviewId as string | number),
    enabled: reviewId != null && reviewId !== "",
    staleTime: 30_000,
    refetchInterval: query => (hasPendingPost(query.state.data) ? PENDING_POLL_MS : false),
  });
}
